import React, { useEffect, useState } from 'react'
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner,
} from 'reactstrap'
import { fetchFichaPjAnexos, getFichaPjAnexoUrl } from './fichaPjApi'

const FichaPjAnexosModal = ({ isOpen, toggle, ficha }) => {
  const [anexos, setAnexos] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!isOpen || !ficha?.fichaPj_id) {
      setAnexos([])
      return undefined
    }
    let cancelled = false
    setLoading(true)
    fetchFichaPjAnexos(ficha.fichaPj_id)
      .then((data) => { if (!cancelled) setAnexos(data) })
      .catch(() => { if (!cancelled) setAnexos([]) })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [isOpen, ficha?.fichaPj_id])

  const titulo = ficha?.pf_nomeExibicao || ficha?.fichaPj_razaoSocial || 'Prestador'

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>
        Anexos — {titulo}
      </ModalHeader>
      <ModalBody>
        {loading && (
          <div className="text-center py-3">
            <Spinner size="sm" color="primary" />
          </div>
        )}
        {!loading && anexos.length === 0 && (
          <p className="text-muted mb-0">Nenhum arquivo anexado.</p>
        )}
        {!loading && anexos.length > 0 && (
          <ul className="list-unstyled mb-0">
                {anexos.map((anexo) => (
                  <li key={anexo.arquivo_id || anexo.arquivo_caminho} className="mb-2">
                    <a
                      href={getFichaPjAnexoUrl(anexo.arquivo_caminho)}
                      target="_blank"
                      rel="noreferrer"
                      style={{ fontSize: '0.9rem' }}
                    >
                      <i className="ri-attachment-line mr-1" />
                      {anexo.arquivo_desc || anexo.arquivo_caminho}
                    </a>
                  </li>
                ))}
          </ul>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Fechar</Button>
      </ModalFooter>
    </Modal>
  )
}

export default FichaPjAnexosModal
